import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 py-10 px-4 text-center" data-id="element-84">
      <div className="container mx-auto" data-id="element-85">
        <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-86">
          MegaPack Reiki
        </h3>
        <div className="flex justify-center gap-6 mb-6 text-sm text-gray-400" data-id="element-87">
          <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-88">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-89">
            Política de Privacidad
          </a>
        </div>
        <p className="text-xs text-gray-600 max-w-lg mx-auto" data-id="element-90">
          © 2025 MegaPack Reiki. Todos los derechos reservados. Este sitio no
          es parte del sitio web de Facebook o Facebook Inc. Además, este sitio
          no está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
}